function shopify_email_hash_refresh() {
	$.ajax({
		type: "POST",
		url: window.ss_manage_notification_settings_config.remote_url,
		dataType: "json",
		data: {
			using_json: "true",
			do: "shopify_email_hash_refresh",
			permanent_domain: window.ss_manage_notification_settings_config.permanent_domain,
			email: window.ss_manage_notification_settings_config.email
		}
	}).done(function (data) {
		if (data.status == 1) {
			location.reload();
		} else {
			var msg = "<strong>Error:</strong><br>";
			if (data.errors && data.errors.length) msg += data.errors.join("<br>");
			$("ss-manage-notification-settings").html(msg);
		}
	});
}

function shopify_manage_notification_settings() {
	$.ajax({
		type: "POST",
		url: window.ss_manage_notification_settings_config.remote_url,
		dataType: "json",
		data: {
			using_json: "true",
			do: "shopify_manage_notification_settings",
			permanent_domain: window.ss_manage_notification_settings_config.permanent_domain,
			email: window.ss_manage_notification_settings_config.email,
			hash: window.ss_manage_notification_settings_config.hash
		}
	}).done(function (data) {
		if (data.status == 1) {
			var template = Handlebars.compile($("#ss_manage_notification_settings_template").html());
			var output = template(data);
			$("ss-manage-notification-settings").html(output);
		} else {
			var msg = "<strong>Error:</strong><br>";
			if (data.errors && data.errors.length) msg += data.errors.join("<br>");
			$("ss-manage-notification-settings").html(msg);
		}
	});
}

function shopify_update_notification_setting(medium, value, field, allowed) {
	$.ajax({
		type: "POST",
		url: window.ss_manage_notification_settings_config.remote_url,
		dataType: "json",
		data: {
			using_json: "true",
			do: "shopify_update_notification_setting",
			permanent_domain: window.ss_manage_notification_settings_config.permanent_domain,
			email: window.ss_manage_notification_settings_config.email,
			hash: window.ss_manage_notification_settings_config.hash,
			medium: medium,
			value: value,
			field: field,
			allowed: allowed ? 1 : 0
		}
	});
}

$(document).ready(function () {
	var $target = $("ss-manage-notification-settings");

	if (!window.ss_manage_notification_settings_config) {
		$target.html("<p>The app did not load correctly. Please refresh the page. If the issue persists, contact us.</p>");
		return;
	}

	var cfg = window.ss_manage_notification_settings_config;

	if (!cfg.customer_id) {
		var template = Handlebars.compile($("#ss_manage_notification_settings_log_in_template").html());
		$target.html(template({ login_url: cfg.login_url }));
		return;
	}

	if (!cfg.email) {
		$target.html("<p>Your customer email is missing from the settings. Please visit your account page to set it.</p>");
		return;
	}

	if (!cfg.hash) {
		shopify_email_hash_refresh();
		return;
	}

	shopify_manage_notification_settings();
});

$(document).on("change", ".ss-contact-flag-toggle", function () {
	var $el = $(this);
	shopify_update_notification_setting(
		$el.data("medium"),
		$el.data("value"),
		$el.data("flag"),
		$el.is(":checked")
	);
});
